import React from 'react';
import { Text, StyleSheet } from 'react-native';
import AdminModal from '../../../Admin/components/AdminModal';
import AdminButton from '../../../Admin/components/AdminButton';
import { AdminColors } from '../../../Admin/constants/adminColors';
import FontFamily from '../../../../constants/fonts';

interface ConfigConfirmModalProps {
  title: string;
  message: string;
  cancelLabel?: string;
  confirmLabel: string;
  confirmVariant?: 'primary' | 'danger';
  onCancel: () => void;
  onConfirm: () => void;
}

/** Confirmation dialog built on AdminModal (window length change, remove override, disable focus area). */
const ConfigConfirmModal: React.FC<ConfigConfirmModalProps> = ({
  title,
  message,
  cancelLabel = 'Cancel',
  confirmLabel,
  confirmVariant = 'primary',
  onCancel,
  onConfirm,
}) => (
  <AdminModal
    visible
    title={title}
    onClose={onCancel}
    width={480}
    footer={
      <>
        <AdminButton label={cancelLabel} variant="secondary" onPress={onCancel} />
        <AdminButton label={confirmLabel} variant={confirmVariant} onPress={onConfirm} />
      </>
    }
  >
    <Text style={styles.message}>{message}</Text>
  </AdminModal>
);

const styles = StyleSheet.create({
  message: {
    fontSize: 14,
    lineHeight: 20,
    color: AdminColors.textPrimary,
    fontFamily: FontFamily.regular,
  },
});

export default ConfigConfirmModal;
